<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card">
      <el-button
        size="medium"
        type="primary"
        plain
        icon="el-icon-plus"
        style="margin-bottom: 10px"
        @click="openDialog(true, null, 0)"
        >新增配置项</el-button
      >
      <el-table :data="data" border size="small" style="margin-top: 10px">
        <el-table-column
          prop="range"
          label="排名区间"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            {{ `${scope.row.range[0]} - ${scope.row.range[1]}` }}
          </template>
        </el-table-column>
        <el-table-column
          prop="rewardsOfDay"
          label="每日奖励"
          align="center"
          width="396"
        >
          <template slot-scope="scope">
            <ShowItems :items="scope.row.rewardsOfDay" />
          </template>
        </el-table-column>
        <el-table-column
          prop="rewardsOfSeason"
          label="赛季奖励"
          align="center"
          width="396"
        >
          <template slot-scope="scope">
            <ShowItems :items="scope.row.rewardsOfSeason" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="remove(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";

export default {
  data() {
    return {
      data: [],
      payPointMap: {},
    };
  },
  components: {
    ShowItems,
  },
  async created() {
    if (this.parameter) {
      this.data = JSON.parse(this.parameter).leaderboardRewards;
    }
  },

  props: {
    parameter: "",
  },

  watch: {},

  computed: {},

  methods: {
    async openDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditHeroUpgradeLeaderboardDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.push(param);
            } else {
              this.$set(that.data, index, param);
            }

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除排名区间为[${this.data[index].range}]的配置项？`
        );
        this.data.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async updatedParam() {
      this.$emit(
        "updated",
        JSON.stringify({ leaderboardRewards: this.data }),
        async () => {
          // 排序
          this.data.sort((x, y) => {
            return x.range[0] - y.range[0];
          });
          for (let index = 0; index < this.data.length; index++) {
            if (index == 0) {
              continue;
            }
            let entry = this.data[index];
            let preEntry = this.data[index - 1];
            if (entry.range[0] - preEntry.range[1] != 1) {
              return { errMsg: "各个排名区之间必须前后衔接" };
            }
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 0px 0;
}
</style>